// isPrerenderCrawl.js
// True while react-snap's puppeteer is executing the page to capture a
// static snapshot (build/index.html and friends) — it runs real Chrome, so
// the app's JS runs exactly as it would for a visitor, and whatever the DOM
// looks like when the crawl captures it is what gets served as the
// pre-rendered page.
//
// react-snap sets navigator.userAgent to the literal string "ReactSnap"
// (see the `userAgent` default in react-snap's own source) — NOT anything
// containing "HeadlessChrome". A puppeteer-launched headless Chrome with no
// override reports "HeadlessChrome" in its real UA string, which is why
// that looked like the right check; it just never matches what react-snap
// itself actually sends. Checking for both covers a future default change
// or a different crawler.
//
// Anything that changes its own rendered output after mount (a random pick,
// a value read from an empty-during-the-crawl localStorage, "now") has to
// skip that change during the crawl — otherwise the snapshot bakes in
// whatever the crawl happened to produce, a real visitor's first paint
// produces something else, and React throws a hydration mismatch (error
// #418/#423) that aborts hydrating the page, taking every effect on it down
// with it.
export function isPrerenderCrawl() {
  try {
    const ua = navigator.userAgent || '';
    return ua.includes('ReactSnap') || ua.includes('HeadlessChrome');
  } catch (e) {
    return false;
  }
}
